
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipCarferry as ObiShipCarferryElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-carferry.js';
 
 
 

 
 export const ObiShipCarferry = createComponent({
   react: React,
   tagName: 'obi-ship-carferry',
   elementClass: ObiShipCarferryElement,
   events: {
     
   }
  });
 
 